import { observable, computed, action } from "mobx";
import { get, post } from 'axios';
import { create, persist } from 'mobx-persist';
// import Environment from '../common/Constants';
const url = '/v2';

class UserStore {
  @persist @observable ui_version_id = 0;
  @persist @observable id = 0;
  @persist @observable token = '';
  @persist @observable hash_id = '';
  @persist @observable first_name = '';
  @persist @observable last_name = '';
  @persist @observable full_name = '';
  @persist @observable email = '';
  @persist @observable phone_primary = '';
  @persist @observable password = '';
  @persist @observable password_verify = '';
  @persist @observable business_id = 0;
  @persist('object') @observable business_primary = {};
  @persist('list') @observable role_list = [];
  @persist('list') @observable businessList = [];

  @computed get is_authenticated() {
  	if (this.token !== ''){
  		return this.token;
  	} else {
  		return false;
  	}
  }

  @action setUiVersion(version){
    this.ui_version_id = version;
  }

	@action get_token(email, password){
    return post(url + '/token', {}, {auth: {username: email,password: password}
      }).then((res) => {
        if (res.data.token){
          // should return: user, order list, favorites,
          this.id = res.data.user.id;
          this.hash_id = res.data.user.hash_id;
          this.first_name = res.data.user.first_name;
          this.last_name = res.data.user.last_name;
          this.full_name = res.data.user.full_name;
          this.email = res.data.user.email;
          this.phone_primary = res.data.user.phone_primary;
          this.role_list = res.data.user.user_role_type_list;
          this.business_id = res.data.user.business_id;
          this.businessList = res.data.user.business_list;
          this.business_primary = res.data.user.business_primary;
          this.token = res.data.token;
        }
        return res.data;
      }).catch((error) => {
        console.log("login error ", error);
        return error;
      });
    }

    @action resetPassword(email){
      return post(url + '/reset', {}, {auth: {username: email,password: ''}
        }).then((res) => {
          return res;
        }).catch((error) => {
          console.log("Reset error ", error);
          return error;
        });
      }


    @action logout(){
      this.id = 0;
      this.token = '';
      this.hash_id = '';
      this.first_name = '';
      this.last_name = '';
      this.full_name = '';
      this.email = '';
      this.phone_primary = '';
      this.business_id = 0;
      this.businessList = [];
      this.business_primary = {};
      this.role_list = [];
    }
}

export default new UserStore();



// WEBPACK FOOTER //
// ./src/store/userStore.js